export default __webpack_public_path__ + "static/media/silent_dot_icon.9dcf9735.png";